export default "__VITE_ASSET__CBqdtoA9__"